import React from 'react';
import { ISVGType } from './SVGType';

const FailedIcon: React.FC<ISVGType> = (props) => {
  const { height = 42, width = 47, color= "#F44336" } = props;

  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 47 42"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 -0.00012207C9.47716 -0.00012207 5.00001 4.47703 5.00001 9.99988V16.9584L1.00001 19.2678C-0.333326 20.0376 -0.333329 21.9621 1 22.7319L5.00001 25.0413V31.9999C5.00001 37.5227 9.47716 41.9999 15 41.9999H37C42.5229 41.9999 47 37.5227 47 31.9999V9.99988C47 4.47703 42.5229 -0.00012207 37 -0.00012207H15Z"
      fill={color}
    />
    <path
      d="M24 27.5119H28.128V31.6399H24V27.5119ZM24 10.9999H28.128V23.3839H24V10.9999Z"
      fill="white"
    />
  </svg>
  );
};

export default FailedIcon;
